import { Drawer, Button, message, Form, Input, Select } from 'antd';
import { DrawerStyle } from './style';
import {AdminSuperviseApi} from "gmrfid-service-community-api-manager"
import { updateAccountApi } from '@/api/reminder';
import { getSupervisionRolesApi } from '@/api/common';
import React, { useEffect, useState } from 'react';

function getParentIds(id, data) {
  // 深度遍历查找
  function dfs(data, id, parents) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      // 找到id则返回父级id
      if (item.id === id || item.parentId === id) return parents;
      // children不存 在或为空则不递归
      if (!item.children || !item.children.length) continue;
      // 往下查找时将当前id入栈
      // parents.push(item.id, {
      //   name: item.name,
      //   uri: item.uri,
      //   id: item.id,
      //   icon: item.icon,
      //   parentId: item.parentId
      // })

      parents.push(item);
      if (dfs(item.children, id, parents).length) return parents;
      // 深度遍历查找未找到时当前id出栈
      parents.pop();
    }
    // 未找到时返回空数组
    return [];
  }
  return dfs(data, id, []);
}

const Add = ({
  setShowDrawer,
  showDrawer,
  tableObj,
  setTableTime,
  setTableObj,
  jurisdictionCode,
  organizationName,
  data,
  tableData = [],
  setTableData,
  setFields,
  selectCode,
}) => {
  const [form] = Form.useForm();
  const [tipTitle, setTipTitle] = useState('');
  const [provinceObj, setProvinceObj] = useState({});
  const [cityObj, setCityObj] = useState({});
  const [areaObj, setAreaObj] = useState({});
  const [streetObj, setStreetObj] = useState({});
  const [communityObj, setCommunityObj] = useState({});

  // 角色类型数据
  const [roles, setRoles] = useState([]);

  // 获取角色类型数据
  useEffect(() => {
    const getSupervisionRoles = async () => {
      const res = await getSupervisionRolesApi();
      setRoles(res || []);
    };

    getSupervisionRoles();
  }, []);

  useEffect(() => {
    let name = '';
    const d = getParentIds(jurisdictionCode, data);
    d.map((it, i) => {
      name += `${it.name}/`;
    });
    d.push(selectCode);

    if (d.length) {
      d[0] &&
        setProvinceObj({
          provinceCode: d[0].code,
          province: d[0].name,
        });
      d[1] &&
        setCityObj({
          cityCode: d[1].code,
          city: d[1].name,
        });
      d[2] &&
        setAreaObj({
          areaCode: d[2].code,
          area: d[2].name,
        });
      d[3] &&
        setStreetObj({
          streetCode: d[3].code,
          street: d[3].name,
        });
    }
    if (d.length >= 5) {
      setCommunityObj({
        communityCode: jurisdictionCode,
        community: organizationName,
      });
    }
    setTipTitle(organizationName);
    form.setFieldsValue({
      organizationName: name + organizationName,
      password: '123456',
    });
    if (tableData.length > 0) {
      form.setFieldsValue({
        // name: `${organizationName}级监管`,
        name: tableData && tableData[0].name,
      });
    }
  }, [jurisdictionCode, tableData]);

  useEffect(() => {
    if (tableObj?.id) {
      form.setFieldsValue({
        phone: tableObj.phone,
        userName: tableObj.userName,
        supervisionRoleCodes: tableObj.supervisionRoleCodes?.[0],
      });
    }
  }, [tableObj, showDrawer, form, roles]);

  const onClose = () => {
    // setTableData([]);
    setFields(pre => ({ ...pre }));
    setShowDrawer(false);
    setTableObj({});
  };

  const onFinish = (values) => {
    delete values.organizationName;

    const vals = {
      ...values,
      supervisionRoleCodes: [values.supervisionRoleCodes],
    };

    const par = {
      id: tableObj?.id,
      jurisdictionCode,
      ...vals,
      ...provinceObj,
      ...areaObj,
      ...cityObj,
      ...streetObj,
      ...communityObj,
    };

    // 新建
    if (!par.id) {
      AdminSuperviseApi.save({ form: par }).then((res) => {
        if (res && res.status === 200) {
          message.success('操作成功');
          setTableTime(Math.random());
          onClose();
        }
      });
    }

    // 编辑
    if (par.id) {
      updateAccountApi(par).then((res) => {
        if (res) {
          message.success('操作成功');
          setTableTime(Math.random());
          onClose();
        }
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={showDrawer}
      className="drawerModal"
      destroyOnClose
      width={720}
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            {!tableObj.id && '新建账号'}
            {tableObj.id && '编辑账号'}
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <div className="drawer-content">
          <Form className="form" name="basic" form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <Form.Item
              label="所属行政区划"
              name="organizationName"
              rules={[
                {
                  required: false,
                  message: '请输入',
                },
              ]}
            >
              <Input style={{ width: 400 }} disabled />
            </Form.Item>
            <Form.Item
              extra={`组织名称使用：行政区划名称+级监管（如：${tipTitle}级监管）`}
              label="组织名称"
              name="name"
              rules={[
                {
                  required: true,
                  message: '请输入',
                  max: 30,
                },
              ]}
            >
              <Input placeholder="请输入" style={{ width: 400 }} disabled={tableData.length > 0} />
            </Form.Item>
            <Form.Item
              label="电话号码"
              name="phone"
              rules={[
                {
                  required: true,
                  message: '请输入',
                  max: 11,
                },
              ]}
            >
              <Input placeholder="请输入电话号码" style={{ width: 400 }} disabled={tableObj.id} />
            </Form.Item>
            <Form.Item
              label="用户昵称"
              name="userName"
              rules={[
                {
                  required: true,
                  message: '请输入',
                  max: 20,
                },
              ]}
            >
              <Input placeholder="请输入用户昵称" style={{ width: 400 }} disabled={tableObj.id} />
            </Form.Item>
            <Form.Item
              label="初始密码"
              name="password"
              rules={[
                {
                  required: false,
                  message: '请输入',
                  max: 20,
                },
              ]}
            >
              <Input style={{ width: 400 }} disabled />
            </Form.Item>
            <Form.Item
              label="角色类型"
              name="supervisionRoleCodes"
              initialValue="construction_supervision"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select options={roles} fieldNames={{ label: 'name', value: 'code' }} />
            </Form.Item>
          </Form>
        </div>
        <div className="handle">
          <Button onClick={onClose} className="cancel">
            取消
          </Button>
          <Button
            className="confirm"
            type="primary"
            onClick={() => {
              form.submit();
            }}
          >
            确定
          </Button>
        </div>
      </DrawerStyle>
    </Drawer>
  );
};
export default Add;
